import {
  Dialog,
  DialogContent as UiDialogContent,
  DialogDescription as UiDialogDescription,
  DialogFooter as UiDialogFooter,
  DialogHeader as UiDialogHeader,
  DialogTitle as UiDialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

import {
  dialogCloseVariants,
  dialogContentVariants,
  dialogDescriptionVariants,
  dialogFooterVariants,
  dialogHeaderVariants,
  dialogOverlayVariants,
  dialogTitleVariants,
} from '../../configs/dialog.config'

import type { ComponentProps } from 'react'

export { Dialog, DialogTrigger }

export function DialogContent({
  className,
  overlayClassName,
  closeClassName,
  ...props
}: ComponentProps<typeof UiDialogContent>) {
  return (
    <UiDialogContent
      className={cn(dialogContentVariants(), className)}
      overlayClassName={cn(dialogOverlayVariants(), overlayClassName)}
      closeClassName={cn(dialogCloseVariants(), closeClassName)}
      {...props}
    />
  )
}

export function DialogHeader({ className, ...props }: ComponentProps<typeof UiDialogHeader>) {
  return <UiDialogHeader className={cn(dialogHeaderVariants(), className)} {...props} />
}

export function DialogFooter({ className, ...props }: ComponentProps<typeof UiDialogFooter>) {
  return <UiDialogFooter className={cn(dialogFooterVariants(), className)} {...props} />
}

export function DialogTitle({ className, ...props }: ComponentProps<typeof UiDialogTitle>) {
  return <UiDialogTitle className={cn(dialogTitleVariants(), className)} {...props} />
}

export function DialogDescription({ className, ...props }: ComponentProps<typeof UiDialogDescription>) {
  return <UiDialogDescription className={cn(dialogDescriptionVariants(), className)} {...props} />
}
